import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { RolesService } from '../roles/roles.service';
import { UsuarioService } from '../usuario/usuario.service';

@Injectable({
  providedIn: 'root'
})
export class LoginBankaoolGuard implements CanActivate {

  constructor(
    private router: Router,
    private usuarioService: UsuarioService,
    private rolesService: RolesService
  ) {}

  canActivate(): boolean {
    if (localStorage.getItem('quiensoy') === 'bankaool' && localStorage.getItem('tkn')) {
      const rid = localStorage.getItem('rid');
      if (rid) {
        this.rolesService.getRol(rid).subscribe(resp => {
          if (resp[0].name === 'SuperAdmin') {
            this.router.navigate(['/dashboardAdmin']);
          } else if (resp[0].name === 'Clientes') {
            this.router.navigate(['/maincliente']);
          } else {
            this.router.navigate(['/panelcontrol/aprobarCreditos/mesaControl']);
          }
        });
        return false;
      }
    }
    return true;
  }
}
